// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"textformat-wrap"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M3 5H21M3 12H17C19 12 21 13 21 15.5C21 18 19 19 17 19H14L16 17M3 19H9","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const TextformatWrapIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'textformat-wrap',
    ref,
    icon: element,
  },
));

TextformatWrapIcon.displayName = 'TextformatWrapIcon';

export default TextformatWrapIcon;
